import { UserInteraction } from '../../entities';

export type UserInteractionState = Record<string, UserInteraction>;

export const userInteractionInitialState: UserInteractionState = {
  date: { isChanged: false },
};
